// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorReturns = (client) => ({
    /**
     * `POST /vendor/returns/:id/receive/confirm`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorConfirmReturnReceiveById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/receive/confirm/route.ts
     */
    confirmReceive: (id, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/receive/confirm", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/returns/:id/dismiss-items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAddDismissReturnItemById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/dismiss-items/route.ts
     */
    createDismissItem: (id, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/dismiss-items", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/returns/:id/receive-items`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAddReceiveReturnItemById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/receive-items/route.ts
     */
    createReceiveItem: (id, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/receive-items", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/returns/:id/dismiss-items/:action_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDismissReturnItemById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/dismiss-items/[action_id]/route.ts
     */
    deleteDismissItem: (id, actionId, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/dismiss-items/:action_id", [id, actionId]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/returns/:id/receive-items/:action_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorReceiveReturnItemById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/receive-items/[action_id]/route.ts
     */
    deleteReceiveItem: (id, actionId, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/receive-items/:action_id", [id, actionId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/returns`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListReturns
     * @source packages/modules/b2c-core/src/api/vendor/returns/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/returns", { method: "GET", query, headers }),
    /**
     * `GET /vendor/returns/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetReturnById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/returns/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/returns/:id/dismiss-items/:action_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateDismissReturnItemById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/dismiss-items/[action_id]/route.ts
     */
    updateDismissItem: (id, actionId, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/dismiss-items/:action_id", [id, actionId]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/returns/:id/receive`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorReturnReceiveById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/receive/route.ts
     */
    updateReceive: (id, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/receive", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/returns/:id/receive-items/:action_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateReceiveReturnItemById
     * @source packages/modules/b2c-core/src/api/vendor/returns/[id]/receive-items/[action_id]/route.ts
     */
    updateReceiveItem: (id, actionId, body, query, headers) => client.fetch(buildPath("/vendor/returns/:id/receive-items/:action_id", [id, actionId]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=returns.js.map